import {GitPullRequestIcon} from '@primer/octicons-react'

import {EffectiveEntryStatus} from '../../../../helpers/effective-entry-status'
import type {EffectiveEntryStatus as EffectiveEntryStatusType} from '../../../../helpers/effective-entry-status'

export function AfterStatusIcon({status}: {status: EffectiveEntryStatusType}) {
  if (status !== EffectiveEntryStatus.After) return null

  return <GitPullRequestIcon size={12} className="color-fg-muted" aria-label="Will not merge: higher up the stack" />
}
